import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/client'
import { withTranslation } from 'react-i18next'
import { Alert, Empty, Spin } from 'antd'

import { GET_CUSTOMER_CLV_QUERY } from './query'
import Detail from './Detail'

const CustomerLifetimeValueContainer = ({ customerId, i18n }) => {
  const { data, loading, error } = useQuery(GET_CUSTOMER_CLV_QUERY, {
    variables: { customerId }
  })

  if (loading) return <Spin />
  if (error) return <Alert type="error" message={error.message} />

  const performance = data && data.customer && data.customer.performance
  if (!performance) {
    return <Empty description={i18n.t('customerForm.clvNoData')} />
  }

  return <Detail performance={performance} />
}

CustomerLifetimeValueContainer.propTypes = {
  customerId: PropTypes.string.isRequired,
  i18n: PropTypes.object.isRequired
}

export default withTranslation('common')(CustomerLifetimeValueContainer)
